import type { PublicKey, Transaction, TransactionSignature, VersionedTransaction } from '@solana/web3.js';

export interface BraveSolanaProvider {
  isBraveWallet?: boolean;
  isConnected?: boolean;
  publicKey?: PublicKey;
  connect: (opts?: { onlyIfTrusted?: boolean }) => Promise<{ publicKey: PublicKey }>;
  disconnect: () => Promise<void>;
  signMessage: (message: Uint8Array, display?: string) => Promise<{ signature: Uint8Array }>;
  signTransaction?: <T extends Transaction | VersionedTransaction>(transaction: T) => Promise<T>;
  signAllTransactions?: <T extends Transaction | VersionedTransaction>(
    transactions: T[]
  ) => Promise<T[]>;
  signAndSendTransaction?: (
    transaction: Transaction | VersionedTransaction,
    options?: Record<string, unknown>
  ) => Promise<{ signature: TransactionSignature }>;
  on?: (event: string, handler: (...args: unknown[]) => void) => void;
  off?: (event: string, handler: (...args: unknown[]) => void) => void;
}

declare global {
  interface Window {
    braveSolana?: BraveSolanaProvider;
  }
}

/** Resolve Brave injected provider (`window.braveSolana` only — not `window.solana`). */
export function getBraveProvider(): BraveSolanaProvider | null {
  if (typeof window === 'undefined') return null;

  const provider = window.braveSolana;
  return provider?.isBraveWallet ? provider : null;
}

export function isBraveWalletAvailable(): boolean {
  return getBraveProvider() != null;
}
